import Companys from './Companys'

export default Companys
